// src/components/TrainerScheduleCard.tsx
import React from "react";
import OverflowHeader from "./OverflowHeader";
import trainerImg from "../assets/trainer.png";

export type TrainerScheduleCardProps = {
  /** Full name; will render on 2 lines */
  name: string;
  /** Credits per hour (accepts number or string to be flexible) */
  rate: number | string;
  /** Small meta e.g., "27F" */
  meta?: string;
  /** Trainer image */
  imageSrc: string;
  /** Gradient flavor */
  gradient: "red" | "dark";
  /** Visible image height (how far it "peeks" above the band). Default 140 */
  imgHeight?: number;
  /** Gradient band height (the bottom area with text). Default 100 */
  bandHeight?: number;
  /** Schedule data */
  schedule: { day: string; time: string }[];
  /** Optional class name on the root */
  className?: string;
  /** Click handler */
  onClick?: () => void;
};

const TrainerScheduleCard: React.FC<TrainerScheduleCardProps> = ({
  name,
  rate,
  meta,
  imageSrc,
  gradient,
  imgHeight = 140,
  bandHeight = 100,
  schedule,
  className,
  onClick,
}) => {
  return (
    <div
      className={`bg-transparent overflow-visible ${onClick ? "cursor-pointer" : ""} ${className || ""}`}
      onClick={onClick}
    >
      {/* HEADER: transparent above gradient, no borders anywhere here */}
      <OverflowHeader
        name={name}
        rate={rate}
        gradient={gradient}
        meta={meta}
        imageSrc={String(imageSrc || trainerImg)}
        imgHeight={imgHeight}
        bandHeight={bandHeight}
      />

      {/* SCHEDULE BOX: the only element with a border */}
      <div className="px-3 py-2 bg-white border border-[#DEDEDE] rounded">
        {(schedule ?? []).slice(0, 3).map((s, idx) => (
          <div
            key={idx}
            className="flex items-center justify-between mx-2 my-2"
          >
            <span
              style={{
                fontFamily: 'Manrope',
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '150%',
                letterSpacing: '0%',
                textAlign: 'center',
                color: '#717171'
              }}
            >
              {s.day}
            </span>
            <span
              style={{
                fontFamily: 'Manrope',
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '120%',
                letterSpacing: '0%',
                textAlign: 'center',
                color: s.time.toLowerCase() === "busy" ? '#B24025' : '#252525'
              }}
            >
              {s.time}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrainerScheduleCard;
